import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown, ArrowRight } from 'lucide-react';
import { nav } from '../mock/data';
import Logo from './Logo';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); setMoreOpen(false); }, [location.pathname]);

  const isActive = (href) => location.pathname === href;

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? 'bg-refocc-cream/90 backdrop-blur-md shadow-sm' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" aria-label="REFOCC home"><Logo /></Link>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-1">
            {nav.map((item) => (
              item.children ? (
                <div key={item.label} className="relative" onMouseEnter={() => setMoreOpen(true)} onMouseLeave={() => setMoreOpen(false)}>
                  <button className="px-4 py-2 text-sm font-medium text-refocc-dark/85 hover:text-refocc-dark transition-colors flex items-center gap-1 rounded-full">
                    {item.label} <ChevronDown size={14} className={`transition-transform ${moreOpen ? 'rotate-180' : ''}`} />
                  </button>
                  <div className={`absolute right-0 top-full mt-1 w-56 bg-white rounded-2xl shadow-xl border border-refocc-dark/10 py-2 transition-all duration-200 ${moreOpen ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2'}`}>
                    {item.children.map((c) => (
                      <Link key={c.href} to={c.href} className="flex items-center justify-between px-4 py-2.5 text-sm text-refocc-dark/85 hover:bg-refocc-cream hover:text-refocc-orange transition-colors">
                        {c.label}
                        <ArrowRight size={14} className="opacity-0 -translate-x-1 group-hover:opacity-100" />
                      </Link>
                    ))}
                  </div>
                </div>
              ) : (
                <Link key={item.href} to={item.href}
                  className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 ${isActive(item.href) ? 'bg-refocc-dark-mid text-white' : 'text-refocc-dark/85 hover:text-refocc-dark hover:bg-refocc-dark/5'}`}>
                  {item.label}
                </Link>
              )
            ))}
          </nav>

          <div className="hidden lg:block">
            <Link to="http://scholarships.refocc.org/" className="inline-flex items-center gap-2 bg-refocc-orange text-white px-5 py-2.5 rounded-full font-medium text-sm hover:bg-[#B97651] transition-colors shadow-sm">
              Scholarship - Apply Now <ArrowRight size={16} />
            </Link>
          </div>

          <button onClick={() => setOpen(!open)} className="lg:hidden p-2 text-refocc-dark" aria-label="Toggle menu">
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`lg:hidden overflow-hidden transition-all duration-300 ${open ? 'max-h-[600px] border-t border-refocc-dark/10' : 'max-h-0'} bg-refocc-cream/95 backdrop-blur`}>
        <div className="px-4 py-3 space-y-1">
          {nav.map(item => (
            item.children ? (
              <details key={item.label} className="group">
                <summary className="flex justify-between items-center px-3 py-2.5 rounded-lg text-refocc-dark font-medium cursor-pointer list-none">
                  {item.label} <ChevronDown size={16} className="group-open:rotate-180 transition-transform" />
                </summary>
                <div className="pl-3">
                  {item.children.map(c => (
                    <Link key={c.href} to={c.href} className="block px-3 py-2 text-sm text-refocc-dark/80 hover:text-refocc-orange">{c.label}</Link>
                  ))}
                </div>
              </details>
            ) : (
              <Link key={item.href} to={item.href} className={`block px-3 py-2.5 rounded-lg font-medium ${isActive(item.href) ? 'bg-refocc-dark text-white' : 'text-refocc-dark hover:bg-refocc-dark/5'}`}>{item.label}</Link>
            )
          ))}
          <Link to="http://scholarships.refocc.org/" className="flex items-center justify-center gap-2 bg-refocc-orange text-white px-5 py-3 rounded-full font-medium mt-3">
            Scholarship - Apply Now <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
